import React, { useState } from "react";
import banner1 from "../../assets/banner1.png";
import banner2 from "../../assets/banner2.png";

const NewQuest = ({ className }) => {
    const [tab, setTab] = useState("social");
    const redirectPage = () => {
        window.open(`https://zealy.io/cw/brufinance/questboard`, "_blank");
        window.location.href = "";
    };

    return (
        <div className={className}>
            <h4 className="font-extrabold text-[30px] lg:text-[36px] leading-[48px] text-white">
                Quests <span className="text-[#FE61BD]">to Complete</span>
            </h4>
            <p className="font-medium text-[16px] lg:text-[20px] leading-[30px] text-[#ababab] mt-2">
                Participate, Engage and Accumulate XP
            </p>
            <div className="flex items-start justify-start gap-3 mt-6">
                <div
                    onClick={() => setTab("social")}
                    className={` ${
                        tab === "social" ? "bg-[#FE61BD40]" : "bg-transparent"
                    } px-[22px] lg:px-[30px] py-[8px] rounded-[60px] border border-[#FE61BD40] cursor-pointer text-white`}
                >
                    Social Media Tasks
                </div>
                <div
                    onClick={() => setTab("chain")}
                    className={` ${
                        tab === "chain" ? "bg-[#FE61BD40]" : "bg-transparent"
                    } px-[22px] lg:px-[30px] py-[8px] rounded-[60px] border border-[#FE61BD40] cursor-pointer text-white`}
                >
                    On-chain Tasks
                </div>
            </div>
            {tab === "social" && (
                <div className="w-full mt-8">
                    <img src={banner1} alt="" className="w-full h-[336px]" />

                    <div className="bg-[#1a1a1a] rounded-[16px] px-[40px] py-[25px] sm:py-[35px] lg:py-[36px] xl:py-[40px] w-full h-[340px] mt-8 text-left">
                        <h4 className="text-[#f0f3ff] font-semibold text-[24px] leading-[30px] mb-4 xl:mb-6">
                            How you can get started :
                        </h4>
                        <p className="text-[#ababab] font-medium text-[16px] sm:text-[18px] xl:text-[20px] leading-[30px] w-full xl:w-[70%] mr-auto">
                            1. Create an account on our Zealy platform if you
                            haven’t already.
                        </p>
                        <p className="text-[#ababab] font-medium text-[16px] sm:text-[18px] xl:text-[20px] leading-[30px] w-full xl:w-[70%] mr-auto">
                            2. Browse and explore the available Quests.
                        </p>
                        <p className="text-[#ababab] font-medium text-[16px] sm:text-[18px] xl:text-[20px] leading-[30px] w-full xl:w-[70%] mr-auto">
                            3. Complete the Quests and earn the XP points.
                        </p>
                        <button
                            onClick={redirectPage}
                            className="font-semibold text-[16px] sm:text-[18px] xl:text-[20px] leading-[30px] text-white rounded-[66px] py-[14px] mt-8 px-[36px] bg-gradient-to-r from-[#8C52FF] to-[#5E17EB]"
                        >
                            Go to Zealy Taskboard
                        </button>
                    </div>
                    {/* background: linear-gradient(90deg, #8C52FF 0%, #5E17EB 100%); */}
                </div>
            )}
            {tab === "chain" && (
                <div className="w-full mt-8">
                    <img src={banner2} alt="" className="w-full h-[336px]" />

                    <div className="bg-[#1a1a1a] rounded-[16px] py-[140px] w-full h-[340px] mt-8 text-[#ffffff40] text-[36px] leading-[48px] text-center font-extrabold">
                        Coming Soon ..
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewQuest;
